import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "\u06A9\u0648\u0631\u062F\u06CC",
  code: "ckb",
  dir: "rtl",
  messages: {
    inputMenu: {
      noMatch: "\u0647\u06CC\u0686 \u0626\u06D5\u0646\u062C\u0627\u0645\u06CE\u06A9 \u0646\u06D5\u062F\u06C6\u0632\u0631\u0627\u06CC\u06D5\u0648\u06D5",
      noData: "\u0647\u06CC\u0686 \u062F\u0627\u062A\u0627\u06CC\u06D5\u06A9 \u0646\u06CC\u06CC\u06D5",
      create: '"{label}" \u062F\u0631\u0648\u0633\u062A\u06A9\u0631\u062F\u0646\u06CC'
    },
    calendar: {
      prevYear: "\u0633\u0627\u06B5\u06CC \u067E\u06CE\u0634\u0648\u0648",
      nextYear: "\u0633\u0627\u06B5\u06CC \u062F\u0627\u0647\u0627\u062A\u0648\u0648",
      prevMonth: "\u0645\u0627\u0646\u06AF\u06CC \u067E\u06CE\u0634\u0648\u0648",
      nextMonth: "\u0645\u0627\u0646\u06AF\u06CC \u062F\u0627\u0647\u0627\u062A\u0648\u0648"
    },
    inputNumber: {
      increment: "\u0632\u06CC\u0627\u062F\u06A9\u0631\u062F\u0646",
      decrement: "\u06A9\u06D5\u0645\u06A9\u0631\u062F\u0646\u06D5\u0648\u06D5"
    },
    commandPalette: {
      placeholder: "\u0641\u06D5\u0631\u0645\u0627\u0646\u06CE\u06A9 \u0628\u0646\u0648\u0648\u0633\u06D5 \u06CC\u0627\u0646 \u0628\u06AF\u06D5\u0695\u06CE...",
      noMatch: "\u0647\u06CC\u0686 \u0626\u06D5\u0646\u062C\u0627\u0645\u06CE\u06A9 \u0646\u06D5\u062F\u06C6\u0632\u0631\u0627\u06CC\u06D5\u0648\u06D5",
      noData: "\u0647\u06CC\u0686 \u062F\u0627\u062A\u0627\u06CC\u06D5\u06A9 \u0646\u06CC\u06CC\u06D5",
      close: "\u062F\u0627\u062E\u0633\u062A\u0646"
    },
    selectMenu: {
      noMatch: "\u0647\u06CC\u0686 \u0626\u06D5\u0646\u062C\u0627\u0645\u06CE\u06A9 \u0646\u06D5\u062F\u06C6\u0632\u0631\u0627\u06CC\u06D5\u0648\u06D5",
      noData: "\u0647\u06CC\u0686 \u062F\u0627\u062A\u0627\u06CC\u06D5\u06A9 \u0646\u06CC\u06CC\u06D5",
      create: '"{label}" \u062F\u0631\u0648\u0633\u062A\u06A9\u0631\u062F\u0646\u06CC',
      search: "\u06AF\u06D5\u0695\u0627\u0646..."
    },
    toast: {
      close: "\u062F\u0627\u062E\u0633\u062A\u0646"
    },
    carousel: {
      prev: "\u067E\u06CE\u0634\u0648\u0648",
      next: "\u062F\u0627\u0647\u0627\u062A\u0648\u0648",
      goto: "\u0628\u0695\u06C6 \u0628\u06C6 \u0633\u0644\u0627\u06CC\u062F\u06CC {slide}"
    },
    modal: {
      close: "\u062F\u0627\u062E\u0633\u062A\u0646"
    },
    slideover: {
      close: "\u062F\u0627\u062E\u0633\u062A\u0646"
    },
    alert: {
      close: "\u062F\u0627\u062E\u0633\u062A\u0646"
    },
    table: {
      noData: "\u0647\u06CC\u0686 \u062F\u0627\u062A\u0627\u06CC\u06D5\u06A9 \u0646\u06CC\u06CC\u06D5"
    }
  }
});
